import { useState } from 'react';

import { Soforok } from '../reszek/Soforok.tsx';
import { Autok } from './Autok.tsx';
import { AlfulValto } from '../reszek/AlfulValto.tsx';

/**
 * Sofőrök és autók. (Megbízás 2.0 / 5.8)
 *
 * Az 1.0-ban a sofőr és az autó egy dolog volt: a rendszám a sofőr során
 * lógott. A 2.0-ban szétvált — a sofőrnél már autót választunk, az autónak
 * pedig saját sora van a három lejárattal.
 *
 * **A készlet továbbra is a sofőrhöz tartozik**, nem az autóhoz. A kettő
 * összekapcsolása a 3.0 dolga.
 */
type Ful = 'sofor' | 'auto';

export function SoforokEsAutok() {
  const [ful, setFul] = useState<Ful>('sofor');

  const valto = (
    <AlfulValto<Ful>
      ertek={ful}
      onValt={setFul}
      fulek={[
        { kulcs: 'sofor', cimke: 'Sofőrök' },
        { kulcs: 'auto', cimke: 'Autók' },
      ]}
    />
  );

  if (ful === 'sofor') return <Soforok fejlec={valto} />;

  return (
    <>
      <div className="dayhead">
        <span style={{ fontSize: 15, fontWeight: 600 }}>Sofőrök és autók</span>
        {valto}
      </div>
      <Autok />
    </>
  );
}
